import React from 'react'
import TextInput from '../components/Input/TextInput'
import ImageInputSecondary from '../components/Input/ImageInputSecondary'
import PrimaryButton from '../components/Button/PrimaryButton'
import FormSection from '../components/Card/FormSection'

const VideoForm = ({ onSubmit, data, isLoading }) => {
  return (
    <form onSubmit={onSubmit} encType="multipart/form-data">
      <div className="flex flex-col gap-3 p-3 lg:pl-0">
        <FormSection
          title="Informasi"
          description="Masukkan nama video, beserta detail untuk melengkapi video tersebut."
        >
          <TextInput
            label="Judul"
            placeholder="Masukkan judul"
            type="text"
            name="title"
            required={true}
            defaultValue={data?.attributes?.title}
          />
          <div className="max-w-[260px]">
            <TextInput
              label="Urutan"
              placeholder="--Pilih urutan--"
              type="number"
              name="sort"
              required={true}
              defaultValue={data?.attributes?.sort}
            />
          </div>
          <TextInput
            label="Video Url"
            placeholder="mis: www.youtube.com/jakmania"
            type="url"
            name="videoUrl"
            required={true}
            defaultValue={data?.attributes?.videoUrl}
          />
        </FormSection>

        <FormSection
          title="Gambar"
          description="Tambahkan gambar sebagai preview singkat mengenai video yang akan ditampilkan. Kamu hanya dapat mengunggah 1 foto saja."
        >
          <ImageInputSecondary
            name="imagePreview"
            required={false}
            defaultValue={data?.attributes?.imagePreview}
            width={300}
            height={168}
            maxFileSize={10485760}
          />
        </FormSection>

        <div className="flex justify-end rounded-card border border-line bg-white shadow-card px-5 py-4">
          <PrimaryButton type="submit" loading={isLoading}>
            Simpan
          </PrimaryButton>
        </div>
      </div>
    </form>
  )
}

export default VideoForm
